import React, {Component} from 'react';
import { InputField } from '../../../common/custom-form/input-filter-component';
import DATEPICKER_OR from '../../../common/custom-form/custom-date-picker.component';
import ButtonIcon from '../../../button';
import Icon from '../../../icon';
import { DataTable } from '../../../common/table/data-table/data-table-component';
export default class LineItem extends Component {
    constructor(props) {
        super(props);
        this.state={
            inputValue:"",
            dataTable:[
                {              
                    HeaderItem:[
                        {
                            name:"Contract Name"
                        },
                        {
                            name:"Vendor"
                        }, {
                            name:"Status"
                        }
                    ],
                    dataItem:[{            
                        columnItem1:"3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired"                       
                    }, {            
                        columnItem1:"3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired"
                    },{            
                        columnItem1:"3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired"
                    }        
                    ]
    
                }
            ]
        }
    }

    getDataOnTable() {     
       
        this.props.getData(false);
      }
    render(){
        return(
            <div className='manage-detail-container'>
                <div className='close-button-detail-container'>
                    <Icon
                    customClassName="close-icon"
                    name="xmark"      
                    size="25px" 
                    onClick={this.getDataOnTable.bind(this)}
                    />
                </div>
                <div className='add-line-label'>
                    <span>Line Items Details</span>
                </div>
                <div className="manage-invoice-detail">
                    <DATEPICKER_OR label="BEGIN DATE" startDate={this.props.startDate} dateSelected={this.props.startDate} selectedDate={(date) => this.setState({startDate:date})}/>
                    <InputField label="SUBSCRIPTION NUBER" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />                  
                    <InputField customClass="grid-item-span-2" label="DESCRIPTION" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <DATEPICKER_OR label="END DATE" startDate={this.props.startDate} dateSelected={this.props.startDate} selectedDate={(date) => this.setState({startDate:date})}/>
                    <InputField label="AMOUNT" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="NUMBER OF MILES" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="USAGE MINUTES" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="USAGE MINUTES PEAK" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="USAGE MINUTES OFF PEAK" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="DATA ALLOCATED" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="PORT SPEED" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="BTN" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="USAGE CALLS" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="USAGE DATA" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="OFF PEAK MINUTES" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="PEAK MINUTES/ALLOWED" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="CHARGE TYPE" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                </div>
                <div className='add-line-label'>
                    <span>Location Address</span>                   
                </div>
                <div className="manage-invoice-detail">
                   <InputField label="LOCATION AUX ID" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                   <InputField label="SITE NAME" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                   <InputField label="ADDRESS 1" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                   <InputField label="ADDRESS 2" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                   <InputField label="CITY" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                   <InputField label="STATE" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                   <InputField label="COUNTRY / LOCATION" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                   <InputField label="ZIP" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                </div>
                <div className="horizontal-separator"></div>
            </div>
        );
    }
}